/**
 * Mapeador de catálogo unificado (productos y servicios) para la vista del POS.
 * Asegura el orden exacto de columnas requerido por Table en modo venta.
 */

export const mapCatalogItemForTable = (item) => {
    if (!item) return item;

    const isService = Boolean(item.is_service ?? (item.type === 'service'));
    const itemValue = Number(item.value ?? item.price ?? 0);
    const tax = item.sell_tax || item.tax || null;

    const mapped = {
        sku: item.sku || (isService ? 'SRV' : 'PROD'),
        name: item.name,
        value: itemValue,
        type_badge: isService ? 'Servicio' : 'Producto',
        is_service: isService,
        type: item.type || (isService ? 'service' : 'product'),
        id: item.id,
        stock: isService ? null : item.stock,
        unit: item.unit ?? item.unit_of_measure,
        warranty: item.warranty,
        sell_tax: tax,
        has_tax: Boolean(tax && (tax.rate > 0 || tax.value > 0)),
        enable: item.enable ?? item.is_enable ?? true,
    };

    // Copiar propiedades restantes sin alterar llaves
    Object.keys(item).forEach((key) => {
        if (!(key in mapped)) {
            mapped[key] = item[key];
        }
    });

    return mapped;
};

export const mapCatalogListForTable = (items) => {
    if (!Array.isArray(items)) return [];
    return items.map(mapCatalogItemForTable);
};
